import {Flex, Text } from '@mantine/core';
import { CommitmentDateIcon, FlagIcon, ReleaseDateIcon } from '../../icons/x-symbol-svgrepo-com';
import { IconAlertOctagon } from '@tabler/icons';
import { MAIN_DARK_PRIMARY } from '../../constants/colors';

const IconsLine = () => {
  return (
    <Flex align="center" gap={16} mt={18} justify='flex-end'>

      <Flex align="center" gap={8}>
        <IconAlertOctagon color={MAIN_DARK_PRIMARY} size={14} />
        <Text size="sm" color="dimmed">Priority</Text>
      </Flex>
      <Flex align="center" gap={8}>
        <FlagIcon color={MAIN_DARK_PRIMARY} />
        <Text size="sm" color="dimmed">Requested date</Text>
      </Flex>
      <Flex align="center" gap={8}>
        <CommitmentDateIcon color={MAIN_DARK_PRIMARY} fill={MAIN_DARK_PRIMARY} />
        <Text size="sm" color="dimmed">Commitment date</Text>
      </Flex>
      <Flex align="center" gap={8}>
        <ReleaseDateIcon color={MAIN_DARK_PRIMARY} />
        <Text size="sm" color="dimmed">Release date</Text>
      </Flex>

    </Flex>
  )
}

export default IconsLine